import { useEffect } from 'react';

const TambolaAppDownloadRedirect = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const packageName = "com.Tambola.Tambola";

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      window.location.href = 'https://play.tambolahouse.live/';
    } else if (/android/i.test(userAgent)) {
      window.location.href = `intent://tambolahouse.live#Intent;scheme=unitydl;package=${packageName};S.browser_fallback_url=https://play.google.com/store/apps/details?id=${packageName};end`;
    } else {
      window.location.href = "https://tambolahouse.live/";
    }
  }, []);

  return <p>Please wait, redirecting...</p>;
};

export default TambolaAppDownloadRedirect;
